import Skeleton from '../../Skeleton';

import { Container } from './styles';

const LoadingMoreNews: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Container>
      <div className="left">
        <Skeleton className="date" />
        <Skeleton className="title" />
        <Skeleton className="description" />
      </div>
      <div className="right">
        <Skeleton className="image" />
      </div>
    </Container>
  );
};

export default LoadingMoreNews;
